"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _faChevronDown = require("@fortawesome/pro-regular-svg-icons/faChevronDown");

var _faChevronRight = require("@fortawesome/pro-regular-svg-icons/faChevronRight");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _classnames = _interopRequireDefault(require("classnames"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderExpandIcon() {
  return function expandIcon(_a) {
    var _b;

    var expandable = _a.expandable,
        expanded = _a.expanded,
        onExpand = _a.onExpand,
        prefixCls = _a.prefixCls,
        record = _a.record;
    var iconPrefix = prefixCls + "-custom-row-expand-icon";
    return React.createElement("button", {
      className: (0, _classnames.default)(iconPrefix, (_b = {}, _b[iconPrefix + "-spaced"] = !expandable, _b)),
      onClick: function onClick(e) {
        onExpand(record, e);
        e.stopPropagation();
      },
      type: "button"
    }, expandable && expanded ? React.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faChevronDown.faChevronDown
    }) : null, expandable && !expanded ? React.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faChevronRight.faChevronRight
    }) : null);
  };
}

var _default = renderExpandIcon;
exports.default = _default;